/**
 * 登录后落地页唯一真源（2026-09-18 定案口径，与 FloatingAssistant HOME ONLY 主页矩阵对齐）
 *
 *   courier                → /courier/orders（配送员唯一主页）
 *   其余（user/operator/admin/super_admin）→ /home（admin 移动端主页就是 /home 店铺首页）
 *
 * 消费点：/login 登录成功、携有效 token 直进登录页、忘记密码重置成功后的自动登录。
 * 新增「登录取代登录态」的入口一律引用本函数——不要在页面里各自再写一份角色分支
 * （否则 courier 从忘记密码重置回来会落到 /home 的死角）。
 */
export function postLoginHome (user) {
  return (user && user.role) === 'courier' ? '/courier/orders' : '/home'
}

export default postLoginHome
